<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年04月23日 13:36:30 +0800
 * @最后修改时间: 2021-11-22 10:02:11
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterFormRecord\components\newShift.vue
 -->
<template>
  <normalDialog
    :dialog="show"
    width="1000"
    maxWidth="1000"
    scrollable
    :title="$t('label_essweb_RosterFormRecord_form_dialog_editShiftTitle')"
    @close="closePorpertyDialog"
  >
    <template v-slot:content>
      <!-- <v-data-table
        :headers="headers"
        v-model="selected"
        hide-default-footer
        :page.sync="page"
        :fixed-header="true"
        :show-select="true"
        item-key="shift_uuid"
        selectable-key="shift_uuid"
        :items="desserts"
        :items-per-page="10"
        @page-count="$tableSetting.pageCount = $event"
        :elevation="0"
      >-->
      <Tabler
        :headers="headers"
        :showFooter="false"
        :height="500"
        selectKey="isSelectable"
        itemKey="shift_uuid"
        :defaultSelect="selected"
        :items="desserts"
        @select="(sel) => (selected = sel)"
        :showSelect="showSelect"
      >
        <!-- <template v-slot:item.action="{ item }">
          <div style="max-width:20px">
            <span class="material-icons-round text--secondary" @click="ShowDetail(item.uuid)">search</span>
          </div>
        </template>-->
        <template v-slot:item.color="{ item }">
          <div style="max-width: 20px">
            <svg-icon
              size="24"
              :fill="item.color_code"
              iconClass="LabeledColour"
            />
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <div class="text--primary table-title">
            {{ $getCommonLangValue(item.shift_name) }}
          </div>
          <div class="text--secondary table-subtitle ma-0">
            {{ $getCommonLangValue(item.shift_description) }}
          </div>
        </template>
        <template v-slot:item.abbr="{ item }">
          {{ item.shift_abbr }}
        </template>
        <template v-slot:item.startTime="{ item }">{{
          $timeMachine(item.start_utc_time)
        }}</template>
        <template v-slot:item.endTime="{ item }">{{
          $timeMachine(item.end_utc_time)
        }}</template>
        <template v-slot:item.total="{ item }">{{
          item.total_working_minutes
        }}</template>
      </Tabler>
    </template>
    <template v-slot:actions>
      <CardActions saveBtn @save="toSave" @cancel="closePorpertyDialog" />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "newShift",
  computed: {
    curSelect() {
      const that = this;
      let arr = [];
      this.desserts.map((item) => {
        if (that.curShiftList.indexOf(item.shift_uuid.toString()) != -1) {
          arr.push(item);
        }
      });
      return arr;
    },
  },
  props: {
    show: { default: false, type: Boolean },
    curShiftList: { default: [], type: Array },
  },
  watch: {
    show(val) {
      const that = this;
      if (val) {
        this.$Sleep(500).then(() => {
          that.selected = [];
          let arr = [];
          that.desserts.map((item) => {
            if (that.curShiftList.indexOf(item.shift_uuid) != -1) {
              arr.push(item);
            }
          });
          that.selected = arr;
        });
      } else {
        this.selected = [0];
      }
    },
    curSelect(val) {
      this.selected = val;
    },
  },
  mounted() {
    this.getList();
  },
  data() {
    return {
      showSelect: true,
      headers: [
        {
          text: "label_essweb_list_components_tools_colorLabel",
          value: "color",
          align: "start",
          width: 20,
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_shiftNameLabel",
          value: "name",
          align: "start",
          sortable: false,
          filter: (value, search, item) => {
            if (!this.search) return true;
            return (
              item.shift_name
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1 ||
              item.shift_description
                .toString()
                .toLocaleUpperCase()
                .indexOf(this.search.toLocaleUpperCase()) != -1
            );
          },
        },
        {
          text: "label_essweb_shift_list_shiftAbbrLabel",
          value: "abbr",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_StartTimeSlotLabel",
          value: "startTime",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_EndTimeSlotLabel",
          value: "endTime",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_totalMinutesLabel",
          value: "total",
          align: "center",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      selected: [1],
      page: 1,
      desserts: [],
      search: "",
    };
  },
  methods: {
    closePorpertyDialog: function () {
      this.$emit("close");
    },
    ShowDetail: function () {},
    getList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift",
        url: "/shift/get-shift-list/",
        data: {},
      }).then((res) => {
        res.data.forEach((item) => {
          that.desserts.push({
            shift_uuid: item.uuid,
            shift_name: item.shift_name,
            shift_description: item.shift_description,
            shift_abbr: item.shift_abbr,
            start_utc_time: item.start_utc_time,
            end_utc_time: item.end_utc_time,
            total_working_minutes: item.total_working_minutes,
            color_code: item.color_code,
          });
        });
      });
    },
    toSave: function () {
      this.$emit("onSave", this.selected);
      this.closePorpertyDialog();
    },
  },
};
</script>
